// create.component.ts

import { Component, OnInit } from '@angular/core';
import { ItemService } from '../../services/item.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CreateComponent implements OnInit {
  title = 'Add Item';
  angForm: FormGroup;

  constructor(private itemservice: ItemService, private fb: FormBuilder) {
    this.createForm();
  }

  createForm() {
    this.angForm = this.fb.group({
      title: ['', Validators.required],
      price: ['', Validators.required]
    });
  }

  addItem(name, price) {
    this.itemservice.addItem(name, price);
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/pages/create/create.component.ts